import {Navigate,useParams} from 'react-router-dom'
import {projectRoute} from './projectEnvironment'
export function LegacyNotebookRoute(){const {projectId,pageId}=useParams();return <Navigate replace to={projectId?projectRoute(projectId,'notebook',pageId):'/notebook'}/>}
